import { Direction, Displaying } from "@bonusx-global/bx-design-system";
import styled from "@emotion/styled";
import Box from "@mui/material/Box";

export const DefaultLayoutInnerContainer = styled(Box)({
  display: Displaying.flex,
  flexDirection: Direction.column,
  width: "100%",
  "& > .MuiBox-root:first-of-type": {
    flexGrow: 0,
  },
});
